import styled from 'styled-components';

const Container = styled.div<{ fontSize: number; color: string; backgroundColor: string }>`
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0px;
    background-color: ${({ backgroundColor }) => backgroundColor};

    > div {
        padding: 0 20px;
        > div {
            font-size: ${({ fontSize }) => fontSize}%;
            color: ${({ color }) => color};
            text-align: left;
        }
    }
`;

const StyleFooterImg = styled.div`
    width: 20%;
    height: 100%;
    padding: 20px;

    img {
        display: block;
        object-fit: contain;
        width: 100%;
        height: 100%;
    }
`;

const DataSources = styled.div`
    span:first-of-type {
        font-weight: bold;
    }
`;

export { Container, DataSources, StyleFooterImg };
